// extracted by mini-css-extract-plugin
export default {"signin":"signinPage_signin__38bKl","signinButton":"signinPage_signinButton__n6sFm","signinLink":"signinPage_signinLink__X-giE"};